export const IFRAME_EVENT = {
  NAVIGATION: 'NAVIGATION',
  LOGOUT: 'LOGOUT',
  NOTIFICATION_COUNT_CHANGE: 'NOTIFICATION_COUNT_CHANGE',
  // TODO: might need more events, like for when opening links etc, that should not be updating the url. Otherwise remove
} as const;
